<template>
  <div class="asc-mxrec-detail-wrapper">
    <asc-spinner-wrapper :loading="loading">
      <asc-card class="asc-mxrec-detail--card" flat>
        <asc-mx-rec-detail
          :data="data"
          :is-investigation-tab="isInvestigationTab"
          :is-recommendation-tab="isRecommendationTab"
          :severity-options="severityOptions"
          :disabled="isDisabled"
          :is-support-info-loading="isSupportInfoLoading"
          :is-custom-alert="isCustomAlert"
          :airline-tier-type-id="airlineTierTypeId"
          @updateSeverity="handleUpdateSeverity"
          @viewPHMAlerts="handleViewPHMAlerts"
        ></asc-mx-rec-detail>
      </asc-card>
    </asc-spinner-wrapper>
    <asc-no-data v-if="isEmpty"></asc-no-data>
  </div>
</template>

<script>
import AscMxRecDetail from '@/components/molecules/AscMxRecDetail'
import AscCard from '@/components/atoms/AscCard'
import AscNoData from '@/components/atoms/AscNoData'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'

import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'

export default {
  name: 'AscMxRecDetailWrapper',

  components: {
    AscCard,
    AscSpinnerWrapper,
    AscNoData,
    AscMxRecDetail,
  },

  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    severityOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSupportInfoLoading: {
      type: Boolean,
      default: false,
    },
    isCustomAlert: {
      type: Boolean,
      default: false,
    },
    airlineTierTypeId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    isEmpty() {
      return !this.loading && Object.keys(this.data).length === 0
    },
    isDisabled() {
      return this.disabled
    },
  },

  methods: {
    //FIXME: didnt find this method
    // handleMxRecRecommendationInput(formData) {
    //   this.$emit('handleRecommendationInput', formData)
    // },
    handleUpdateSeverity(severityId) {
      this.$emit('updateMxRecAlertDetails', {
        severityId: severityId,
      })
    },
    handleViewPHMAlerts(e) {
      this.$emit('viewPHMAlerts', e)
    },
  },
}
</script>

<style lang="scss">
.asc-mxrec-detail-wrapper {
  height: 100%;

  .asc-spinner-wrapper {
    height: 100%;
  }

  .asc-mxrec-detail--card {
    min-height: 224px;
    height: 100%;
  }
}
</style>
